/**
 * Pure helpers for the AdminDemoTab anti-scraping controls (strict_mode +
 * plot_bin_granularity). Extracted from AdminDemoTab.jsx so the client-side
 * JSON validation is unit-testable without a JSX renderer (repo has no
 * @testing-library/preact on this branch — see tests/radar/story-card.test.jsx).
 */

/**
 * Parse + validate the plot_bin_granularity JSON textarea draft.
 *
 * Client-side checks are shape-only (valid JSON object of positive numbers).
 * The authoritative floor/positivity validation (>= vetted default per B3)
 * happens server-side on PUT — a violation there surfaces as a 422 that
 * AdminDemoTab shows via the existing configError alert.
 *
 * @param {string} text
 * @returns {{value: Object<string,number>|null, error: string|null}}
 */
export function parsePlotBinGranularityDraft(text) {
  const trimmed = (text ?? '').trim();
  if (!trimmed) {
    return { value: {}, error: null };
  }

  let parsed;
  try {
    parsed = JSON.parse(trimmed);
  } catch (e) {
    return { value: null, error: 'Invalid JSON — check syntax (e.g. missing quotes or commas).' };
  }

  if (parsed === null || typeof parsed !== 'object' || Array.isArray(parsed)) {
    return { value: null, error: 'Must be a JSON object of { "metric_key": number }.' };
  }

  for (const [key, val] of Object.entries(parsed)) {
    if (typeof val !== 'number' || !Number.isFinite(val) || val <= 0) {
      return { value: null, error: `"${key}" must be a positive number.` };
    }
  }

  return { value: parsed, error: null };
}
